<template>
  <div class="container ">
    <h1 class="text-center my-3">صفحه جست‌و‌جو</h1>
    <search-input/>

    <section v-for="(section,sectionName) in result">
      <SearchSections v-if="section.data.length" :section="section" :section-name="sectionName"/>

      <div class="text-center" v-else>
        <h1>{{ searchTypes[sectionName] }}</h1>
        <p>موردی یافت نشد.</p>
      </div>

    </section>

  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {searchTypes} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Search'
import SearchInput from "./Search/SearchInputArchive";
import SearchSections from "./Search/SearchSections";

export default {
  name: "Search",
  components: {SearchInput, SearchSections},
  data() {
    return {
      searchParams: {
        words: '',
        type: '',
      },
      searchTypes
    }
  },
  computed: {
    ...mapGetters({
      result: 'Search/getResult'
    })
  },
  methods: {
    setSearchParameters() {
      this.searchParams.words = this.$route.params.words
      this.searchParams.type = this.$route.params.type
    },
  },
  mounted() {
    this.setSearchParameters();
    this.$store.dispatch('Search/search', {type: this.searchParams.type, words: this.searchParams.words})
  },
  watch: {
    $route(to, from) {
      this.setSearchParameters();
      this.$store.dispatch('Search/search', {type: this.searchParams.type, words: this.searchParams.words})
    }
  }
}
</script>

<style scoped>

</style>